<script lang="ts">
import { VNode } from 'vue';
import { Component, Prop, Vue, ProvideReactive } from 'vue-property-decorator';
import { ProductModel } from '@/src/types/the-q-api';

@Component({})
export default class AdProductDataProperty extends Vue {
  @ProvideReactive()
  @Prop({ default: null })
  private product!: ProductModel | null;

  render(): VNode[] | VNode | undefined {
    return this.$scopedSlots.default?.({});
  }
}
</script>
